
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// // ✅ React Router setup
// import { BrowserRouter } from 'react-router-dom';
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;

// const root = ReactDOM.createRoot(document.getElementById('root'));

// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </React.StrictMode>
// );

// // ✅ Optional: Measure performance
// reportWebVitals();




import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import $ from 'jquery';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Set jQuery globally
window.$ = $;
window.jQuery = $;

// React app render
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Optional: Measure performance
reportWebVitals();

// Register service worker for PWA support
serviceWorkerRegistration.register();
